/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { applicantAction } from 'shared/store/actions';
import classNames from 'classnames';
import './NavStepper.scss';
import { FormattedMessage } from 'react-intl';
import CloseIcon from 'assets/icons/close.svg';

const Step = ({
  number, isActive, isCompleted,
}) => (
  <li>
    <section className={`${isActive ? 'active' : ''} ${isCompleted && !isActive ? 'completed' : ''}`}>
      <span className="nav-stepper__list__num">{number.match(/(\d+)/)[0]}</span>
      <em />
    </section>

    <small><FormattedMessage id={`${number}.title`} /></small>
  </li>
);

const NavStepper = ({ showStepper = true, ...props }) => {
  const stepperClasses = classNames({
    'nav-stepper': true,
    'nav-stepper--hidden': !showStepper,
  });
  const onHandleClose = () => {
    props.onSaveApplicant();
    props.onClose();
  };
  return (
    <nav className={stepperClasses}>
      <strong className="nav-stepper__title">
        {props.navTitle && (
        <span className={props.history.location.pathname === '/payment-success' || props.history.location.pathname === '/payment-fail' ? 'displayTitle' : 'default'}>
          <FormattedMessage id={props.navTitle} />
        </span>
        )}
      </strong>
      {showStepper ? (
        <ul className="nav-stepper__list">
          {
          props.steps && props.steps.map((item, idx) => (
            <Step
              key={`step-${idx}`}
              number={idx === 5 && props.history.location.pathname === '/payment' ? 'payment6' : item.id}
              isActive={props.currentStep === item.id}
              isCompleted={item.isCompleted}
            />
          ))
        }
        </ul>
      ) : null}
      <img className="nav-stepper__close" src={CloseIcon} alt="close" onClick={() => onHandleClose()} />
    </nav>
  );
};

NavStepper.propTypes = {
  /** Nav step title */
  navTitle: PropTypes.node,
  // /** array of steps */
  // steps: PropTypes.arrayOf(PropTypes.object),
  /** close function */
  onClose: PropTypes.func,
  /** currentStep */
  currentStep: PropTypes.string,
};

NavStepper.defaultProps = {
  navTitle: 'step.idPassport',
  // steps: [ // @Todo: create this list in redux store
  //   {
  //     id: 'step1',
  //     isActive: false,
  //     isCompleted: true,
  //   }, {
  //     id: 'step2',
  //     isActive: true,
  //     isCompleted: false,
  //   }, {
  //     id: 'step3',
  //     isActive: false,
  //     isCompleted: false,
  //   }, {
  //     id: 'step4',
  //     isActive: false,
  //     isCompleted: false,
  //   }, {
  //     id: 'step5',
  //     isActive: false,
  //     isCompleted: false,
  //   }, {
  //     id: 'step6',
  //     isActive: false,
  //     isCompleted: false,
  //   },
  // ],
  currentStep: 'step2',
  onClose: () => {},
};

const mapStateToProps = ({ stepsReducer }) => ({
  currentStep: stepsReducer.currentStep,
  steps: stepsReducer.steps,
});

const mapDispatchToProps = dispatch => ({
  onSaveApplicant: () => dispatch(applicantAction.updateApplicant()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavStepper);
